import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id A792FD60-AF2F-4EDD-8CCB-42FFBEE61286
 * name folder-off
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-off.svg
 * tags
 * - Files / Folders 
 */
export const FolderOffIcon = createSvgIcon(<><path d="M22.11 21.46L20.84 22.73L18.11 20H4C2.9 20 2 19.11 2 18V6C2 5.42 2.25 4.9 2.64 4.53L1.11 3L2.39 1.73L22.11 21.46M22 18V8C22 6.89 21.1 6 20 6H12L10 4H7.2L21.88 18.68C21.96 18.47 22 18.24 22 18Z" /></>, 'FolderOffIcon');
export default FolderOffIcon